var map = {
	"./canva.png": 7566,
	"./chatgpt.png": 374,
	"./chegg.png": 9939,
	"./coursehero.png": 2296,
	"./gptzero.png": 2646,
	"./grammarly.png": 4349,
	"./instagram.png": 2183,
	"./logos": 3723,
	"./logos.js": 3723,
	"./quillbot.png": 4157,
	"./quizlet.png": 353,
	"./snapicon.png": 4244,
	"./sparknotes.png": 3173,
	"./symbolab.png": 6286,
	"./wolframalpha.png": 4487
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5379;